import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";

const Transactions = () => {
  const [WalletData, setWalletData] = useState([]);
  const [WalletDataHistory, setWalletDataHistory] = useState([]);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [WithDrawalAmount, setWithDrawalAmount] = useState(100);

  const UserID = localStorage.getItem("UserID");

  const GetUserWallet = async () => {
    await axios({
      method: "GET",
      url: MyApiUrl + "EarningWallet/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        axios({
          method: "GET",
          url: MyApiUrl + "UserWithdrawalHistory/" + UserID + "",
          headers: {
            "content-type": "application/json",
          },
        })
          .then((response1) => {
            setWalletDataHistory(response1.data);
          })
          .catch((error) => {
            console.log(error);
          });
        setWalletData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const SplitDate = (Date) => {
    let Datee = Date.split("T")[0].split("-");
    console.log(Datee);
    return `${Datee[2]}-${Datee[1]}-${Datee[0]}`;
  };

  const Filter = () => {
    if (FromDate === "" || FromDate === null) {
      alert("Please Select From Date");
    } else if (ToDate === "" || ToDate === null) {
      alert("Please Select To Date");
    } else {
      let obj = {
        FromDate: FromDate,
        ToDate: ToDate,
        UserID: UserID,
      };
      axios
        .post(MyApiUrl + "UserWithdrawalHistoryFilter", obj)
        .then((response) => {
          setWalletDataHistory(response.data);
        });
    }
  };

  function formatTo12Hour(dateString) {
    const date = new Date(dateString); // Parse the ISO string as a Date object in UTC
  
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getUTCFullYear();
  
    let hours = date.getUTCHours(); // Get UTC hours
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  
    // Convert to 12-hour format with AM/PM
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  const ResetFilter = () => {
    setFromDate("");
    setFromDate("");
    GetUserWallet();
  };

  React.useEffect(() => {
    GetUserWallet();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <section
          className="content-inner section-wrapper3 overflow-hidden"
          style={{ paddingTop: "7em" }}
        >
          <div className="container">
            <div className="section-head text-center">
              <h2 className="title wow fadeInUp" data-wow-delay="0.4s">
                Wallet Transactions
              </h2>
            </div>
            <div
              className="row align-items-center"
              style={{
                background: "rgb(255, 255, 255)",
                borderRadius: "5px",
                border: "1px solid #e5e5e5",
                margin: "0%",
              }}
            >
              <div className="col-md-4">
                <div
                  style={{
                    background: "#373838",
                    borderRadius: "5px",
                    padding: "0px 15px 0px 15px",
                    margin: "5% 0% 5% 0%",
                    borderBottom: "1px solid",
                  }}
                >
                  <label
                    style={{ margin: "0" }}
                    className="form-label text-primary"
                  >
                    From Date
                  </label>
                  <div className="input-line input-white">
                    <input
                      name="dzName"
                      required=""
                      type="date"
                      className="form-control"
                      placeholder="Customer Name"
                      value={FromDate}
                      onChange={(event) => {
                        setFromDate(event.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div
                  style={{
                    background: "#373838",
                    borderRadius: "5px",
                    padding: "0px 15px 0px 15px",
                    margin: "5% 0% 5% 0%",
                    borderBottom: "1px solid",
                  }}
                >
                  <label
                    style={{ margin: "0" }}
                    className="form-label text-primary"
                  >
                    To Date
                  </label>
                  <div className="input-line input-white">
                    <input
                      name="dzName"
                      required=""
                      type="date"
                      className="form-control"
                      placeholder="Customer Name"
                      value={ToDate}
                      onChange={(event) => {
                        setToDate(event.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <button
                  className="btn btn-success"
                  onClick={Filter}
                  style={{ width: "100%", marginBottom: "5%" }}
                >
                  Filter
                </button>
              </div>
              <div className="col-md-2">
                <button
                  onClick={ResetFilter}
                  className="btn btn-warning"
                  style={{ width: "100%", marginBottom: "5%" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
          <div className="circle1 dz-parallax"></div>
        </section>
        <section className="content-inner overflow-hidden section-wrapper2">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <p
                  style={{
                    fontSize: "25px",
                    fontWeight: "700",
                    color: "#454545",
                    textAlign: "center",
                    borderBottom: "1px solid #afafaf",
                    paddingBottom: "3%",
                  }}
                >
                  Withdrawal History
                </p>
              </div>
              <div className="col-md-12">
                <table className="table table-hover table-stripped table-responsive">
                  {WalletDataHistory.length > 0 ? (
                    WalletDataHistory.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            width: "25%",
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          <img
                            src={"assets/images/tran.jpg"}
                            style={{ width: "80%" }}
                            alt="Transaction"
                          />
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          {item.withdrawal_status === 0 ||
                          item.withdrawal_status === "0" ? (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "rgb(201 160 0)",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Pending
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                }}
                              >
                                {formatTo12Hour(item.withdrawal_date)}
                              </p>
                            </React.Fragment>
                          ) : item.withdrawal_status === 1 ||
                            item.withdrawal_status === "1" ? (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "#1bb919",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Accepted
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                }}
                              >
                                {formatTo12Hour(item.withdrawal_date)}
                              </p>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <p
                                style={{
                                  color: "rgb(241 18 18)",
                                  textAlign: "left",
                                  fontWeight: "900",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Rejected
                              </p>
                              <p
                                style={{
                                  marginBottom: "0",
                                  textAlign: "left",
                                  fontSize: "15px",
                                  paddingBottom: 0,
                                }}
                              >
                                {formatTo12Hour(item.withdrawal_date)}
                              </p>
                            </React.Fragment>
                          )}
                        </td>
                        <td
                          style={{
                            borderBottom: "1px solid #999999",
                            padding: "0",
                          }}
                        >
                          <p
                            style={{
                              color: "rgb(71 71 71)",
                              textAlign: "right",
                              fontWeight: "600",
                              fontSize: "20px",
                              marginTop: "5%",
                              marginBottom: 0,
                              paddingBottom: 0,
                            }}
                          >
                            ₹ {item.withdrawal_amount}
                          </p>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", color: "#888" }}
                      >
                        No wallet data available.
                      </td>
                    </tr>
                  )}
                </table>
              </div>
            </div>
          </div>
          <svg
            className="bg-image"
            viewbox="0 0 1920 264"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M380.438 172.814C453.01 193.873 513.641 155.505 584.547 164.16C655.453 172.814 667.579 158.976 745.427 139.953C823.275 120.931 828.459 164.16 866.504 141.666C904.549 119.172 899.365 127.827 923.571 143.378C947.777 158.93 1026.27 173.972 1123.98 139.861C1174.61 122.181 1250.61 73.1669 1278.19 69.2328C1302.91 65.7153 1340.4 107.046 1380.15 91.495C1419.96 75.9439 1438.98 69.0014 1461.43 79.3689C1482.44 89.042 1505.16 76.9158 1515.72 73.1206C1522.52 72.3801 1530.81 79.9242 1548.21 81.035C1612.08 85.2005 1703.58 93.1612 1743.38 56.8753C1783.19 20.543 1817.76 -6.52413 1845.44 2.13081C1865.85 8.51788 1902.27 52.4028 1919.95 29.2527V258.093H-2.27667V214.272C17.9491 196.916 41.7386 160.853 69.0919 174.553C107.137 193.575 123 184.16 154.985 149.126C182.57 138.759 203.192 131.642 195 141.5C186.808 151.312 205.48 151.903 253.438 135.143C271.442 138.429 275.515 140.882 279.634 153.98C283.707 167.078 282.92 156.245 301.711 161.984C320.594 167.77 352.761 164.807 380.438 172.814Z"
              fill="var(--dark-light)"
            ></path>
            <path
              d="M1011.97 185.033C873.215 192.114 733.764 185.45 595.192 194.382C395.619 207.203 195.213 252.236 -2.27667 239.138V263.139H1920V104.824C1617.77 87.8385 1316.28 169.482 1011.97 185.033Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1272.36 159.464C1272.36 159.464 1248.43 147.986 1247.51 130.769C1257.09 131.741 1274.3 148.958 1274.3 148.958C1274.3 148.958 1265.7 126.002 1281.94 112.626C1283.84 126.973 1277.59 148.217 1277.59 148.217C1277.59 148.217 1281.71 141.877 1291.48 138.961C1289.25 146.042 1284.63 153.447 1272.36 159.464Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M798.422 188.632C798.422 188.632 774.494 177.154 773.568 159.936C783.148 160.908 800.366 178.125 800.366 178.125C800.366 178.125 791.757 155.169 808.003 141.793C809.9 156.141 803.652 177.385 803.652 177.385C803.652 177.385 807.771 171.044 817.537 168.128C815.315 175.163 810.733 182.615 798.422 188.632Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1552.19 120.033C1552.19 120.033 1542.42 119.385 1540.85 110.915C1542.42 106.842 1547.79 115.636 1547.79 115.636C1547.79 115.636 1549.69 100.547 1558.16 94.8545C1553.44 107.767 1550.29 115.636 1550.29 115.636C1550.29 115.636 1557.23 105.546 1565.38 104.944C1562.88 113.09 1552.19 120.033 1552.19 120.033Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M575.504 196.897C575.504 196.897 565.738 196.249 564.165 187.779C565.738 183.706 571.107 192.5 571.107 192.5C571.107 192.5 573.005 177.411 581.475 171.719C576.754 184.631 573.606 192.5 573.606 192.5C573.606 192.5 580.549 182.41 588.695 181.808C586.242 190 575.504 196.897 575.504 196.897Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1733.94 104.342L1720.01 88.3282C1725.15 87.31 1734.96 99.1586 1734.96 99.1586C1734.96 99.1586 1730.84 87.8192 1741.67 73.8879C1745.33 87.31 1733.94 104.342 1733.94 104.342Z"
              fill="var(--dark)"
            ></path>
            <path
              d="M1662.43 23.5308V110.034"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1636.98 28.1594C1636.98 41.2113 1641.84 46.9041 1661.37 46.0247"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M1688.31 46.2561C1688.31 59.3079 1683.45 65.0008 1663.92 64.1214"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M117.901 158.215V244.672"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M92.445 162.844C92.445 175.896 97.3047 181.588 116.836 180.709"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
            <path
              d="M143.773 180.94C143.773 193.992 138.913 199.685 119.382 198.806"
              stroke="var(--dark)"
              stroke-width="3.1879"
              stroke-miterlimit="10"
              stroke-linecap="round"
            ></path>
          </svg>
          <div className="circle1 style-1 dz-parallax"></div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Transactions;
